import { Avatar, Box, IconButton, Typography } from "@mui/material";
import { AttachmentIcon } from "src/icons/attachment";
import { Download } from "src/icons/download";
import { Trash } from "src/icons/trash";
import { convertFileSizeToSizeUnits } from "src/utils/convert-file-size-to-size-units";

interface Props {
  path: string;
  size: number;
  onDelete?: () => void;
  onDownload?: () => void;
}

const FileCard = ({ size, path, onDelete, onDownload }: Props) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Avatar
          sx={{
            backgroundColor: "#E1E3EA",
            color: "text.secondary",
            height: 36,
            width: 36,
          }}
        >
          <AttachmentIcon />
        </Avatar>
        <Box sx={{ display: "flex", justifyContent: "space-between", flexDirection: "column" }}>
          <Typography variant="subtitle2">{path}</Typography>
          <Typography variant="caption" color="text.secondary">
            {convertFileSizeToSizeUnits(size)}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        {onDownload ? (
          <IconButton onClick={onDownload}>
            <Download />
          </IconButton>
        ) : null}
        {onDelete ? (
          <IconButton onClick={onDelete}>
            <Trash />
          </IconButton>
        ) : null}
      </Box>
    </Box>
  );
};

export default FileCard;
